export default __webpack_public_path__ + "static/media/dots-horizontal.8466c681.svg";